import { heroCategories, hotEvents } from "@/mocks/chigua";

export default function Hero() {
  const top = hotEvents[0];

  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20terracotta%20and%20amber%20ink%20wash%20texture%20with%20soft%20paper%20grain%20and%20journalism%20number%20typography%20collage%20moody%20editorial%20background%20cinematic&width=1800&height=1000&seq=chigua-hero-bg&orientation=landscape"
          alt="在线吃瓜深度复盘平台暖色编辑风背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-32 md:pt-40 pb-16 md:pb-20">
        <div className="max-w-3xl anim-fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-400/40 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            <span className="text-xs md:text-sm text-accent-100 tracking-wide">今日瓜田更新 · 8 月 28 日</span>
          </div>

          <h1 className="font-heading text-3xl md:text-6xl font-extrabold leading-tight text-background-50">
            不只看表面热闹
            <br />
            <span className="text-accent-400">更要理清来龙去脉</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-background-200">
            在线吃瓜专注事件始末的<span className="text-background-50 font-medium">完整时间线</span>梳理与
            <span className="text-background-50 font-medium">前因后果背景解析</span>。从起点到爆发,每一步都帮你梳理清楚,
            让你逐层拆解、深度复盘,一眼看懂整场瓜的完整脉络。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-400 transition-colors"
            >
              开始吃瓜 · 看最新复盘
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-200 text-background-100 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-time-line" aria-hidden="true"></i>
              体验完整时间线
            </a>
          </div>
        </div>

        {/* 今日头条卡片 */}
        <div className="mt-14 md:mt-16">
          <div className="grid lg:grid-cols-3 gap-4 lg:gap-5 items-stretch">
            <a
              href="#timeline"
              className="group lg:col-span-2 relative overflow-hidden rounded-xl"
            >
              <img
                src={top.cover}
                alt={top.title}
                className="w-full h-56 md:h-72 lg:h-80 object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <div className="flex items-center gap-2 flex-wrap mb-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs whitespace-nowrap">
                    今日头条
                  </span>
                  <span className="px-2.5 py-1 rounded-md bg-background-50/20 text-background-100 text-xs whitespace-nowrap">
                    {top.category}
                  </span>
                  <span className="text-xs text-background-300">{top.duration}</span>
                </div>
                <h2 className="font-heading text-xl md:text-3xl font-bold text-background-50">
                  {top.title}
                </h2>
                <p className="mt-2 hidden md:block text-sm text-background-200 line-clamp-2">{top.summary}</p>
              </div>
            </a>

            {/* 栏目入口 */}
            <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
              <div className="rounded-xl bg-background-50/5 border border-background-200/40 p-5 flex flex-col justify-between">
                <div>
                  <span className="w-9 h-9 rounded-md bg-accent-500/20 text-accent-400 flex items-center justify-center">
                    <i className="ri-fire-line text-lg" aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading text-lg font-bold text-background-50 mt-4">400+</h3>
                  <p className="text-xs text-background-300 mt-1">已复盘事件与深度解析</p>
                </div>
              </div>
              <div className="rounded-xl bg-background-50/5 border border-background-200/40 p-5 flex flex-col justify-between">
                <div>
                  <span className="w-9 h-9 rounded-md bg-secondary-500/25 text-secondary-300 flex items-center justify-center">
                    <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading text-lg font-bold text-background-50 mt-4">5 大</h3>
                  <p className="text-xs text-background-300 mt-1">瓜田栏目,持续跟进事件</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 栏目快捷入口 */}
        <div className="mt-8 flex flex-wrap items-center gap-2.5">
          <span className="text-xs text-background-400 tracking-wide whitespace-nowrap">热门瓜田:</span>
          {heroCategories.slice(1).map((c) => (
            <a
              key={c}
              href="#hot"
              className="px-3 py-1.5 rounded-full bg-background-50/10 text-background-100 text-xs border border-background-200/30 whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              {c}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}